import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAG_HANDLE_WIDTH,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const StationsGridTableWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "stations-grid-table-panel-wrapper",
  },
)`
  min-width: 100%;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${rydeColors.smoke};

  .grid_panel {
    background-color: ${greyMui._100};
    overflow: auto;
    position: absolute;
  }
  .splitter {
    position: absolute;
    inset-inline-start: 0;
    top: 0;
    bottom: 0;
    background-color: ${greyMui._300};
    cursor: col-resize;
    width: ${DRAG_HANDLE_WIDTH}px;
    z-index: ${ScreenDepth.GRID_SPLITTER};
    &:hover {
      background-color: ${greyMui._400};
    }
  }
  .map_panel {
    position: absolute;
    inset-inline-end: 0;
    top: 0;
    bottom: 0;
    background-color: ${rydeColors.smoke};
    padding: 3px;
    margin-inline-start: ${DRAG_HANDLE_WIDTH - 1}px;
  }
`;
